import { render, staticRenderFns } from "./MigrationOverlay.vue?vue&type=template&id=2470a07e&scoped=true&"
import script from "./MigrationOverlay.vue?vue&type=script&lang=ts&"
export * from "./MigrationOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./MigrationOverlay.vue?vue&type=style&index=0&id=2470a07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470a07e",
  null
  
)

export default component.exports